import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/collections/redux/actions';
import ItemForm from './item/ItemForm';
import CustomLoader from '../common/CustomLoader';
import CommonPageComponent from '../../common/ui/CommonPageComponent';

export class CreateCollectionItem extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { projectId, collectionId, version } = this.props.match.params;
    this.props.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
  }

  render() {
    const { collections, actions, match, home, common } = this.props;
    const { projectId, version } = match.params;
    const { projectDetail } = collections;

    const {
      loadProjectCollectionDetailPending,
      selectedCollection,
      selectedItem,
      deleteItemPending,
      saveCollectionItemPending,
      updateCollectionItemPending,
    } = collections;

    if (loadProjectCollectionDetailPending || !selectedCollection) {
      return (
        <CommonPageComponent parentClassName="collections-create-collection-item">
          <div className="text-center">
            <CustomLoader
              loading={loadProjectCollectionDetailPending || !selectedCollection}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }

    const isShowDeleteLoader = deleteItemPending;
    const isShowCreateOrUpdateLoader = saveCollectionItemPending || updateCollectionItemPending;
    return (
      <CommonPageComponent parentClassName="collections-create-collection-item">
        <ItemForm
          projectId={projectId}
          version={version}
          collection={selectedCollection}
          actions={actions}
          collections={collections}
          item={selectedItem}
          isShowDeleteLoader={isShowDeleteLoader}
          isShowCreateOrUpdateLoader={isShowCreateOrUpdateLoader}
          history={this.props.history}
          projectDetail={projectDetail}
          home={home}
          common={common}
        />
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCollectionItem);
